export default {
  props: {
    images: { type: Array },
    show: { type: Boolean },
    callback: { type: Function },
    variant: { type: Object },
  },

  data() {
    return {
      selectedImageIndex: null,
    };
  },

  methods: {
    close,
    pick,
    confirm,
    remove,
  },

  mounted() {
    let _self = this;

    if (_self.variant && _self.variant.image_url) {
      _self.images.forEach(function (image, index) {
        if (image.src === _self.variant.image_url) {
          _self.selectedImageIndex = index;
        }
      });
    }
  },
};

function pick(imageIndex) {
  if (imageIndex === this.selectedImageIndex) {
    this.selectedImageIndex = null;
  } else {
    this.selectedImageIndex = imageIndex;
  }
}

function remove() {
  if (this.variant.image_url !== null) {
    this.callback(this.variant, this.selectedImageIndex, "DELETE");
    this.close();
  }
}

function confirm() {
  if (this.selectedImageIndex !== null) {
    this.callback(this.variant, this.selectedImageIndex, "ADD");
    this.close();
  }
}

function close() {
  this.selectedImageIndex = null;
  this.$parent.isAssignImageModalVisible = false;
  this.$parent.selectedVariant = null;
}
